<template>
    <app-wrapper>
        <app-header :loan="defaultLoan" :page="'Home'" medium-max-width="max-w-1000" short-top-header>

            <template #navigation/>

            <template v-if="defaultLoan" #top-top>
                <div class="flex justify-between items-center">
                    <p class="text-sm font-semibold">Loan #{{ defaultLoan.id }}</p>
                    <loan-status-tag :loan="defaultLoan"/>
                </div>
            </template>

            <template v-if="defaultLoan" #top-bottom>
                <LoanBalance :loan="defaultLoan"/>
            </template>

            <template v-if="defaultLoan" #bottom-left>
                <LoanSummaryLeft :loan="defaultLoan"/>
            </template>

            <template v-if="defaultLoan" #bottom-right>
                <LoanSummaryRight :loan="defaultLoan"/>
            </template>

            <template v-if="defaultLoan" #bottom-bottom>
                <template v-if="eligibleLoanId">
                    <div v-if="paymentsNeededForEligibility > 0" class="flex border-t border-solid border-color-[#DEE8F9] justify-between pt-3.5 mb-4">
                        <div>
                            Eligible for more credit
                        </div>
                        <div class="font-semibold text-right">
                            in {{ paymentsNeededForEligibility }} payments
                        </div>
                    </div>
                    <a v-else :href="`/account/loans/${eligibleLoanId}?apply-for-more=true`" class="block w-full no-underline mt-2 bg-action rounded text-white text-center text-lg font-semibold py-3">
                        Apply for More Credit
                    </a>
                </template>

                <a :href="`/account/loans/${defaultLoan.id}`" class="block w-full no-underline mt-2 bg-white border border-primary-700 rounded text-primary-700 text-center text-lg font-semibold py-3" data-testid="view-loan-link">
                    View Loan
                </a>

                <LoanAccountClosed :loan="defaultLoan"/>

                <LoanPaymentsDeactivated :loan="defaultLoan"/>
            </template>

        </app-header>
        <app-body medium-max-width="max-w-1000" footer short>

            <template #main>
                <template v-if="otherLoans.length">
                    <h4 class="text-lg leading-snug">
                        Previous Loans
                    </h4>

                    <div class="flex flex-col mt-4 space-y-4">
                        <a :href="`/account/loans/${previousLoan.id}`" v-for="previousLoan in otherLoans" class="flex no-underline text-black font-medium cursor-pointer items-center justify-between border p-4 pb-3.5 rounded-lg bg-gray-50 border-gray-200">
                            <div>
                                Loan #{{ previousLoan.id }} | {{ previousLoan.amount | money(0) }}
                            </div>
                            <div>
                                <loan-status-tag :loan="previousLoan"/>
                            </div>
                        </a>
                    </div>
                </template>

                <template v-if="closedOtherLoans.length">
                    <div class="relative mt-4">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                            <div class="w-full border-t border-gray-300"/>
                        </div>
                        <div class="relative flex justify-center">
                            <button @click.prevent="showingClosed = ! showingClosed" type="button" class="inline-flex items-center gap-x-1.5 rounded-lg bg-gray-50 border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                {{ showingClosed ? 'hide' : 'show' }}
                            </button>
                        </div>
                    </div>

                    <div v-if="showingClosed" class="flex flex-col mt-4 space-y-4">
                        <a :href="`/account/loans/${previousLoan.id}`" v-for="previousLoan in closedOtherLoans" class="flex no-underline text-black font-medium cursor-pointer items-center justify-between border p-4 pb-3.5 rounded-lg bg-gray-50 border-gray-200">
                            <div>
                                Loan #{{ previousLoan.id }} | $-.--
                            </div>
                            <div>
                                <loan-status-tag :loan="previousLoan"/>
                            </div>
                        </a>
                    </div>
                </template>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
import LoanStatusTag from "../app/LoanStatusTag.vue";
import LoanBalance from "../components/LoanBalance.vue";
import LoanSummaryLeft from "../components/LoanSummaryLeft.vue";
import LoanSummaryRight from "../components/LoanSummaryRight.vue";
import LoanPaymentsDeactivated from "../components/LoanPaymentsDeactivated.vue";
import LoanAccountClosed from "../components/LoanAccountClosed.vue";

export default {
    components: {
        LoanStatusTag, 
        LoanBalance,
        LoanSummaryLeft,
        LoanSummaryRight,
        LoanPaymentsDeactivated,
        LoanAccountClosed
    },
    mixins: [
        require('../mixins/InteractsWithGtag').default,
        require('../mixins/InteractsWithLoans').default
    ],

    computed: {
        otherLoans() {
            if (!this.defaultLoan) return [];
            return this.loans.filter(loan => loan.id !== this.defaultLoan.id && !['closed', 'closed_remarketable'].includes(loan.status));
        },

        closedOtherLoans() {
            if (!this.defaultLoan) return [];
            return this.loans.filter(loan => loan.id !== this.defaultLoan.id && ['closed', 'closed_remarketable'].includes(loan.status));
        },

        paymentsNeededForEligibility() {
            return this.requiredPaymentsRemaining > 0 ? this.requiredPaymentsRemaining : 0;
        },
    },
    props: {
        eligibleLoanId: {
            type: Number,
            default: null
        },
        requiredPaymentsRemaining: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            future: true,
            gTagPageName: 'account-dashboard',
            defaultLoan: this.loans[0] ?? null,
            showingClosed: false,
        }
    }
}
</script>